export const checkIsBorder = (i: number) => {
    return i === 2 || i === 5 || i === 8;
}